import { parseISO } from "date-fns";
import React from "react";

import { faEllipsis } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { DropDownMenu } from "@performyard/py-components";

// components
import Avatar from "../../../../../components/Avatar";
import Container from "../../../../../components/Container";
import FormattedDateTime from "../../../../../components/FormattedDateTime";
import Link from "../../../../../components/Link";
import { ScrollableColumn } from "../../../../../components/TableLite/TableLiteScrollable/TableLiteScrollable";
import Typography from "../../../../../components/Text";
import TruncatedText from "../../../../../components/Text/TruncatedText";

// hooks
import useSearchQueryParams from "../../../../../hooks/useSearchQueryParams";

// utils
import toEmployeeUrl from "../../../../../utils/URLs/Employee";

// config
import Config from "../Config";
// styles
import css from "../Forms.module.scss";

const FormsCols: ScrollableColumn[] = [
	{
		id: "name",
		label: "Forms",
		isSortable: true,
		width: 412,
		getter: (form) => {
			const { name, baseId } = form;

			return (
				<Link href={`/edit-review-form/${baseId}`}>
					<TruncatedText maxWidth={396} size="paragraph-3" weight="regular" text={name} />
				</Link>
			);
		},
	},
	{
		id: "created_at",
		label: "Last Update",
		isSortable: true,
		width: 188,
		getter: (form) => {
			const { createdAt } = form;
			const parsedDate = parseISO(createdAt);

			return (
				<FormattedDateTime
					dateSize="medium"
					hasTime={true}
					delimiter={"•"}
					date={parsedDate}
					size="paragraph-3"
					weight="regular"
				/>
			);
		},
	},
	{
		id: "updated_by.name",
		label: "Modified By",
		isSortable: true,
		width: 188,
		getter: (form) => {
			const { updatedBy } = form;
			if (!updatedBy?._id) {
				return null;
			}
			return (
				<Link href={toEmployeeUrl(updatedBy?._id)}>
					<Container gap="4px" verticalAlignment="center">
						<Avatar size={20} id={updatedBy?._id} />
						<TruncatedText
							useTooltip="never"
							maxWidth={156}
							size="paragraph-3"
							weight="regular"
							text={updatedBy.name}
						/>
					</Container>
				</Link>
			);
		},
	},
	{
		id: "relatedWorkflowCount",
		label: "Used In",
		isSortable: true,
		width: 164,
		getter: (form) => {
			const { relatedWorkflows } = form;
			const { handleQueryChange } = useSearchQueryParams({ schema: Config.adminFormsPageSchema });
			if (!relatedWorkflows?.length) {
				return null;
			}
			return (
				<button className={css.unstyledButton} onClick={() => handleQueryChange({ relatedWorkflow: form._id })}>
					<Typography size="paragraph-3" weight="regular" color="primary-5" className={css.selectableColumn}>
						{relatedWorkflows?.length || 0} Template{relatedWorkflows.length > 1 ? "s" : ""}
					</Typography>
				</button>
			);
		},
	},
	{
		id: "questionsCount",
		label: "Questions",
		isSortable: true,
		width: 88,
		getter: (form: any) => {
			const { questions } = form;

			return (
				<Typography size="paragraph-3" weight="regular">
					{questions.length || 0}
				</Typography>
			);
		},
	},

	{
		id: "options",
		label: "",
		isSortable: false,
		width: 32,
		getter: (form) => {
			const { _id } = form;

			const { handleQueryChange } = useSearchQueryParams({ schema: Config.adminFormsPageSchema });

			return (
				<DropDownMenu
					options={[
						{
							key: "delete",
							label: "Delete",
							onClick: () => {
								handleQueryChange({ deleteFormId: _id });
							},
						},
					]}
					className="flex justify-center text-paragraph-3 font-regular text-neutral-5 hover:text-neutral-7"
					placement="bottom-end"
				>
					<FontAwesomeIcon icon={faEllipsis} />
				</DropDownMenu>
			);
		},
	},
];
export default FormsCols;
